'use strict';

export default class UpdatedController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;

    this.page = 1;
    this.params = {
      offset: this.page - 1,
      limit: 20,
      sortBy: 'createdAt',
      order: -1,
      type: 1
    };
  }

  $onInit() {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page;
    }
    this.getFirmwares()
    this.getCount()
  }

  getFirmwares(type) {
    if (type) {
      this.params.type = +type || 1
    }
    console.log(this.params)
    this.params.offset = (this.page - 1) * this.params.limit;
    this.$http.get('/api/firmware/updated', {params: this.params}).then(res => {
      this.firmwares = res.data;
    });
  }

  getCount() {
    this.$http.get('/api/firmware/countFirmwareVersion').then(res => {
      this.versions = res.data;
    });
  }

  pageChanged() {
    this.$state.go('firmwares.updated', {page: this.page});
  }
}



// WEBPACK FOOTER //
// ./client/app/firmwares/updated/updated.controller.js